var ZINDEX = /*#__PURE__*/function (ZINDEX) {
  ZINDEX[ZINDEX["FLOATING_BACKGROUND"] = 1000] = "FLOATING_BACKGROUND";
  ZINDEX[ZINDEX["FLOATING"] = 1100] = "FLOATING";
  ZINDEX[ZINDEX["SKIPLINK"] = 1200] = "SKIPLINK";
  return ZINDEX;
}(ZINDEX || {});
var ASSET_CDN_URL = /*#__PURE__*/function (ASSET_CDN_URL) {
  ASSET_CDN_URL["ICONS"] = "https://cdn6.agoda.net/cdn-design-system/icons/";
  ASSET_CDN_URL["ILLUSTRATIONS"] = "https://cdn6.agoda.net/cdn-design-system/illustrations/";
  return ASSET_CDN_URL;
}(ASSET_CDN_URL || {});
var DRONE_EXTENSION_ENABLED = 'droneExtensionEnabled';

export { ASSET_CDN_URL, DRONE_EXTENSION_ENABLED, ZINDEX };
//# sourceMappingURL=constants.js.map
